window.addEventListener( 'message', function( event ) {
  // Optionally, verify the origin of the message
  if ( event.origin === 'https://www2.dtexsystems.com' ) {
    const iframe = document.getElementById( 'salesforce-form' );
    iframe.style.height = event.data + 'px';
  }
} );